import type { RouteRecordName } from 'vue-router'

interface ConversationDocumentTitleOptions {
  conversationTitle?: string | null
  characterName?: string | null
}

interface DocumentTitleOptions extends ConversationDocumentTitleOptions {
  routeName?: RouteRecordName | null
  metaTitle?: string | null
}

export function joinTitleParts(parts: Array<string | null | undefined>): string {
  return parts
    .filter((part): part is string => typeof part === 'string' && part.trim().length > 0)
    .map((part) => part.trim())
    .join(' | ')
}

export function buildConversationDocumentTitle({
  conversationTitle,
  characterName,
}: ConversationDocumentTitleOptions): string {
  const normalizedConversationTitle =
    typeof conversationTitle === 'string' ? conversationTitle.trim() : ''
  const normalizedCharacterName = typeof characterName === 'string' ? characterName.trim() : ''

  const hasRealConversationTitle =
    normalizedConversationTitle.length > 0 &&
    normalizedConversationTitle.toLowerCase() !== 'conversation'

  if (hasRealConversationTitle) {
    return joinTitleParts([normalizedConversationTitle, normalizedCharacterName, 'Storyteller'])
  }

  if (normalizedCharacterName) {
    return joinTitleParts([`Chatting with ${normalizedCharacterName}`, 'Storyteller'])
  }

  return 'Storyteller'
}

export function buildDocumentTitle({
  routeName,
  metaTitle,
  conversationTitle,
  characterName,
}: DocumentTitleOptions): string {
  if (routeName === 'conversation') {
    return buildConversationDocumentTitle({ conversationTitle, characterName })
  }

  if (routeName === 'character') {
    const normalizedCharacterName = typeof characterName === 'string' ? characterName.trim() : ''
    if (normalizedCharacterName) {
      return joinTitleParts([normalizedCharacterName, 'Storyteller'])
    }
  }

  if (typeof metaTitle === 'string' && metaTitle.trim().length > 0) {
    return joinTitleParts([metaTitle, 'Storyteller'])
  }

  return 'Storyteller'
}
